import { NavLink } from "react-router-dom";
import { LayoutDashboard, List, Repeat, PiggyBank, GitCompareArrows, MessageSquare, Crown, Upload, Wallet, Mail } from "lucide-react";
import Navbar from "./Navbar";
import { useAuth } from "../context/AuthContext";

const NAV = [
    { to: "/dashboard", label: "Overview", icon: LayoutDashboard, id: "overview" },
    { to: "/budget", label: "Safe to spend", icon: Wallet, id: "budget" },
    { to: "/transactions", label: "Transactions", icon: List, id: "transactions" },
    { to: "/chat", label: "Ask Sift", icon: MessageSquare, id: "chat" },
    { to: "/savings", label: "Savings Finder", icon: PiggyBank, id: "savings", pro: true },
    { to: "/subscriptions", label: "Subscriptions", icon: Repeat, id: "subscriptions", pro: true },
    { to: "/compare", label: "Compare months", icon: GitCompareArrows, id: "compare", pro: true },
    { to: "/digest", label: "Weekly review", icon: Mail, id: "digest", pro: true },
    { to: "/upload", label: "Statements", icon: Upload, id: "upload" },
];

export default function AppShell({ children, title, subtitle, actions, testid }) {
    const { isPro } = useAuth();
    return (
        <div className="min-h-screen bg-background" data-testid={testid}>
            <Navbar />
            <div className="mx-auto flex max-w-7xl gap-8 px-4 py-6 sm:px-6 lg:px-8">
                <aside className="hidden w-56 shrink-0 lg:block">
                    <nav className="sticky top-20 space-y-1" data-testid="sidebar-nav">
                        {NAV.map(({ to, label, icon: Icon, id, pro }) => (
                            <NavLink key={to} to={to} data-testid={`sidebar-${id}`}
                                className={({ isActive }) => `flex items-center gap-2.5 rounded-xl px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-primary/15 text-primary" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}>
                                <Icon className="h-4 w-4" /> {label}
                                {pro && !isPro && <Crown className="ml-auto h-3 w-3 text-accent" />}
                            </NavLink>
                        ))}
                    </nav>
                </aside>
                <main className="min-w-0 flex-1">
                    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
                        <div>
                            {subtitle && <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{subtitle}</p>}
                            <h1 className="mt-1 font-heading text-2xl font-extrabold tracking-tight text-foreground sm:text-3xl">{title}</h1>
                        </div>
                        {actions}
                    </div>
                    {children}
                </main>
            </div>
            <div className="glass fixed inset-x-0 bottom-0 z-40 flex justify-around border-t border-border px-1 py-1.5 lg:hidden" data-testid="mobile-nav">
                {NAV.slice(0, 5).map(({ to, label, icon: Icon, id }) => (
                    <NavLink key={to} to={to} data-testid={`mobile-nav-${id}`}
                        className={({ isActive }) => `flex flex-col items-center gap-0.5 rounded-lg px-2 py-1 text-[10px] ${isActive ? "text-primary" : "text-muted-foreground"}`}>
                        <Icon className="h-5 w-5" /> {label.split(" ")[0]}
                    </NavLink>
                ))}
            </div>
            <div className="h-16 lg:hidden" />
        </div>
    );
}
